import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { BannerList_banners_edges_node } from "@saleor/banners/types/BannerList";
import { BannerListUrlSortField } from "@saleor/banners/urls";
import Container from "@saleor/components/Container";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SearchBar from "@saleor/components/SearchBar/SearchBar";
import { sectionNames } from "@saleor/intl";
import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import BannerList from "../BannerList";
import { BannerFilterKeys, BannerListFilterOpts } from "./filters";

export interface BannerListPageProps
  extends PageListProps,
    ListActions,
    FilterPageProps<BannerFilterKeys, BannerListFilterOpts>,
    SortPage<BannerListUrlSortField>,
    TabPageProps {
  defaultCurrency: string;
  banners: BannerList_banners_edges_node[];
  totalCount: number;
  customAction;
  activeTab;
}

const BannerListPage: React.FC<BannerListPageProps> = ({
  currencySymbol,
  currentTab,
  filterOpts,
  initialSearch,
  onAdd,
  onAll,
  onFilterChange,
  onSearchChange,
  customAction,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  activeTab,
  totalCount,
  ...listProps
}) => {
  const intl = useIntl();

  const breadcrumbDirectory = [
    {
      name: "Banners"
    }
  ];

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.banners)}>
        <Button
          onClick={onAdd}
          variant="contained"
          color="primary"
          id="createBannerBtn"
        >
          <FormattedMessage
            defaultMessage="Create Banner"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <SearchBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All",
            description: "tab name"
          })}
          currentTab={currentTab}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Banners"
          })}
          tabs={tabs}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
          disablePlusOneTab={true}
          hideAction={true}
          customAction={customAction}
        />
        <BannerList {...listProps} totalCount={totalCount} />
      </Card>
    </Container>
  );
};
BannerListPage.displayName = "BannerListPage";
export default BannerListPage;
